import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef } from 'react';
import { navs } from '@/constants';
import Icon from '@/components/base/Icon';
import { gettext } from '@/utils/langsBook';
import Linker from '../Linker';
import styled from 'styled-components';
import { ADDRESS_TYPE } from '@/constants/Address';
var NavGroupLayout = styled.div.withConfig({
    displayName: "Nav__NavGroupLayout",
    componentId: "sc-769ygh-0"
})([
    "transition:all 0.1s;",
    " .group-box{box-shadow:0px 2px 6px rgba(0,0,0,0.08);",
    " .group-item{white-space:nowrap;&:hover > div{",
    "}}.active{",
    "}}"
], {
    "position": "absolute",
    "transformOrigin": "top",
    "top": "100%",
    "left": "-32px",
    "paddingTop": "8px",
    "zIndex": "10"
}, {
    "padding": "8px",
    "backgroundColor": "var(--color-box-bg)",
    "borderRadius": "8px"
}, {
    "color": "var(--color-text-primary)",
    "backgroundColor": "var(--color-select-bg)",
    "fontWeight": "500",
    "borderRadius": "4px"
}, {
    "color": "var(--color-text-primary)",
    "backgroundColor": "var(--color-select-bg)",
    "borderRadius": "4px"
});
var Nav = function() {
    var router = useRouter();
    var groupRef = useRef(null);
    var getActiveClass = useCallback(function(path) {
        var isSub = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var currentPath = router.pathname;
        var isRoot = path === '/';
        var isHome = isRoot && currentPath === path;
        var addressPath = '/assets/address';
        if (currentPath.match(addressPath)) {
            var ref, ref1;
            var type = (ref1 = (ref = router.query) === null || ref === void 0 ? void 0 : ref.address) === null || ref1 === void 0 ? void 0 : ref1.split(':')[1];
            if ([
                ADDRESS_TYPE.nft,
                ADDRESS_TYPE.token
            ].includes(type) && path === '/assets') {
                return 'text-primary';
            }
            if (path.match(type)) {
                return 'text-primary';
            }
            return '';
        }
        if (isHome) {
            return 'active';
        }
        if (!isRoot && currentPath.match(path)) {
            return isSub ? 'active' : 'text-primary ';
        }
        return '';
    }, [
        router
    ]);
    useEffect(function() {
        if (groupRef.current) {
            var groupELs = groupRef.current.querySelectorAll('.group');
            if (groupELs) {
                groupELs.forEach(function(gEl) {
                    gEl.onmouseover = function(e) {
                        var targetEl = e === null || e === void 0 ? void 0 : e.currentTarget;
                        if (targetEl) {
                            var ref;
                            var targetClassList = (ref = targetEl.querySelector('.group-warp')) === null || ref === void 0 ? void 0 : ref.classList;
                            if (targetClassList) {
                                // targetClassList.add('animate-selectShow')
                                targetClassList.remove('hidden'); // targetClassList.remove('animate-selectHide')
                            }
                        }
                    };
                    gEl.onmouseleave = function(e) {
                        var targetEl = e === null || e === void 0 ? void 0 : e.currentTarget;
                        if (targetEl) {
                            var ref;
                            var targetClassList = (ref = targetEl.querySelector('.group-warp')) === null || ref === void 0 ? void 0 : ref.classList;
                            if (targetClassList) {
                                // targetClassList.add('animate-selectHide')
                                // targetClassList.remove('animate-selectShow')
                                targetClassList.add('hidden'); // targetEl.dataset.state = 'leaving'
                            // setTimeout(() => {
                            //   targetEl.dataset.state = 'finished'
                            // }, 300)
                            }
                        }
                    };
                });
            }
        }
    }, [
        groupRef.current
    ]);
    return(/*#__PURE__*/ _jsx("nav", {
        className: "flex items-center text-desc w-[100%] border-b-[1px] border-base bg-box container-min-w",
        children: /*#__PURE__*/ _jsx("div", {
            className: "mx-auto container-w",
            ref: groupRef,
            children: navs.map(function(nav) {
                var isActive = getActiveClass(nav.path);
                var textColor = isActive ? 'text-primary font-semibold' : '';
                var textBorder = isActive ? /*#__PURE__*/ _jsx("span", {
                    className: "absolute bottom-0 w-full left-0 h-[2px] rounded-[2px] bg-primary"
                }) : '';
                return(/*#__PURE__*/ _jsx("div", {
                    className: "".concat(getActiveClass(nav.path), " inline-block cursor-pointer ml-[20px] mr-[52px]"),
                    children: nav.children ? /*#__PURE__*/ _jsx("div", {
                        className: "group",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "py-[14px] pr-[20px] relative",
                            children: [
                                /*#__PURE__*/ _jsxs("nav", {
                                    className: textColor,
                                    children: [
                                        gettext(nav.name),
                                        /*#__PURE__*/ _jsx(Icon, {
                                            type: "dropdown",
                                            className: "".concat(textColor, " text-[16px] absolute top-[18px] group-hover:rotate-180 transition-transform")
                                        }),
                                        textBorder
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(NavGroupLayout, {
                                    className: "group-warp hidden",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "group-box",
                                        children: nav.children.map(function(subNav) {
                                            /*#__PURE__*/ return _jsx(Linker, {
                                                className: "group-item",
                                                href: subNav.path,
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "".concat(getActiveClass(subNav.path, true), " px-[24px] py-[12px]"),
                                                    children: gettext(subNav.name)
                                                })
                                            }, subNav.name);
                                        })
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ _jsx(Linker, {
                        href: nav.path,
                        children: /*#__PURE__*/ _jsxs("span", {
                            className: "".concat(textColor, " inline-block py-[14px] relative"),
                            children: [
                                gettext(nav.name),
                                textBorder
                            ]
                        })
                    })
                }, nav.name));
            })
        })
    }));
};
export default Nav;
